import React from 'react'
import { usePostRequest } from '../hooks/request'
import { USER_LIST } from '../urls'
import UserForm from './UserForm'
import { useMessage } from '../hooks/message'

export default function UserCreate({ onCancel, reload }) {
    const [showMessage] = useMessage()
    const users = usePostRequest({ url: USER_LIST })

    async function onSubmit(data) {
        const { success, error } = await users.request({ data })
        if (success) {
            reload.request()
            onCancel()
            showMessage('Пользователь успешно создан', 'is-success')
        }
        if (error) {
            showMessage(error?.data?.detail || 'Ошибка при создании пользователя', 'is-danger')
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered"><b>Добавить пользователя</b></h1>

            <UserForm
                loading={users.loading}
                onCancel={onCancel}
                onSubmit={onSubmit}
            />
        </div>
    )
}
